// Segnale di presenza: dice al backend che l'utente sta usando l'app.
//
// auth.users.last_sign_in_at cambia solo a un login nuovo: chi tiene
// ElevenBase installata come app resta loggato per mesi senza mai
// "accedere". touch_activity (migration 20260924000200) aggiorna
// user_activity.last_seen_at, da cui l'admin legge l'ultima attivita'.
//
// Chiamata all'apertura dell'app e quando torna in primo piano, al massimo
// una volta ogni 15 minuti per browser (timestamp in localStorage).
import { supabaseV2 } from "./supabase";

const KEY = "eb.activity.touched_at";
const MIN_INTERVAL_MS = 15 * 60_000;
// Team registrato dall'ultimo tocco di questa pagina: il primo tocco parte
// prima che il team corrente sia noto, e va ripetuto una volta col team.
let lastTouchedTeam: string | null = null;

function isInstalledApp(): boolean {
  try {
    return (
      window.matchMedia?.("(display-mode: standalone)")?.matches ||
      (navigator as any).standalone === true
    );
  } catch {
    return false;
  }
}

export async function touchActivity(teamId: string | null, force = false): Promise<void> {
  try {
    const last = Number(localStorage.getItem(KEY) || 0);
    if (!force && Date.now() - last < MIN_INTERVAL_MS) return;
    localStorage.setItem(KEY, String(Date.now()));
  } catch {
    // localStorage non disponibile: si manda comunque, senza throttle.
  }
  lastTouchedTeam = teamId;
  const { error } = await supabaseV2.rpc("touch_activity", {
    _team_id: teamId,
    _platform: isInstalledApp() ? "pwa" : "web",
  });
  if (error) console.warn("[activity] touch fallito:", error.message);
}

// Da chiamare quando il team corrente diventa noto: se l'ultimo tocco era
// partito senza team, lo ripete una volta col team.
export function touchActivityForTeam(teamId: string | null): void {
  if (teamId && lastTouchedTeam !== teamId) void touchActivity(teamId, true);
}

// Aggancia il segnale all'apertura e ai ritorni in primo piano. Restituisce
// la funzione di pulizia per useEffect.
export function startActivityHeartbeat(getTeamId: () => string | null): () => void {
  void touchActivity(getTeamId());
  const onVisible = () => {
    if (document.visibilityState === "visible") void touchActivity(getTeamId());
  };
  document.addEventListener("visibilitychange", onVisible);
  window.addEventListener("focus", onVisible);
  return () => {
    document.removeEventListener("visibilitychange", onVisible);
    window.removeEventListener("focus", onVisible);
  };
}
